import * as React from "react"
import { SVGProps } from "react"

const SvgUserIdentifierCardBold = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-0.6 -0.6 14 14" {...props}>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2}>
      <path d="M1.242 2.072h10.316s.785 0 .785.784v7.088s0 .784-.785.784H1.242s-.785 0-.785-.784V2.856s0-.784.785-.784M8.557 5.375h1.817M8.557 7.176h1.817" />
      <path d="M3.207 5.676a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0" />
      <path d="M2.426 8.661c.239-.453.574-.828.973-1.088.4-.26.85-.396 1.308-.396s.909.136 1.308.396c.4.26.735.635.973 1.088" />
    </g>
  </svg>
)
export default SvgUserIdentifierCardBold
